module.exports = __webpack_public_path__ + "media/src/assets/spinner-4e9606d9a170eb8e8280d9fe895eb3de.svg";